import { useMutation } from '@libs/use';

import * as API from '../requests';

type UseDeleteBrokerChangeRequestQueryParamsType = {
  onSuccess?: (...arg: any[]) => void;
};

export default function useDeleteBrokerChangeRequestQuery({
  onSuccess,
}: UseDeleteBrokerChangeRequestQueryParamsType) {
  const {
    execute: deleteBrokerChangeRequest,
    isPending: isDeletingBrokerChangeRequest,
    isSuccess: isSuccessDeletingBrokerChangeRequest,
    ...query
  } = useMutation(
    (requestId: number | string) => API.deleteBrokerChangeRequest(requestId),
    {
      onSuccess,
    }
  );

  return {
    deleteBrokerChangeRequest,
    isDeletingBrokerChangeRequest,
    isSuccessDeletingBrokerChangeRequest,
    ...query,
  };
}
